import { Controller } from "@hotwired/stimulus"

// Auto-populates the item name field when selecting a product from the dropdown
export default class extends Controller {
  static targets = ["select", "name"]

  populate() {
    const select = this.selectTarget
    const nameField = this.nameTarget

    if (select.value && !nameField.value) {
      nameField.value = select.options[select.selectedIndex].text
    }
  }
}
